import { v4 as uuidv4 } from "uuid";
import { useListenFromRenderer } from "../message";
import { postToRenderer } from "../message/utils";
import { fetchGatewayInferenceJob } from "./shared/fetch-inference-job";
import { getTargetEditorImage } from "./shared/target-editor-image";

const TOOL_NAME = "Relighting";

const callRelight = async (
	messageId: string,
	jwt: string,
	option: string,
	tool_document_id: string,
) => {
	const { success } = await getTargetEditorImage({
		commandName: TOOL_NAME,
		resultLayerName: TOOL_NAME,
		processImage: async ({ imageBase64, executionContext }) => {
			const data = {
				inputs: {
					$img: imageBase64,
					$option: option,
				},
				params_index: 1,
				tool_document_id,
				jwt,
			};
			return fetchRelight(data, executionContext, messageId);
		},
	});
	return success;
};

const callRelightAuto = async (
	messageId: string,
	jwt: string,
	optionIndex: number,
	tool_document_id: string,
) => {
	const { success } = await getTargetEditorImage({
		commandName: TOOL_NAME,
		resultLayerName: TOOL_NAME,
		processImage: async ({ imageBase64, executionContext }) => {
			const data = {
				inputs: {
					$img: imageBase64,
					$option: String(optionIndex),
				},
				params_index: 0,
				tool_document_id,
				jwt,
			};
			return fetchRelight(data, executionContext, messageId);
		},
	});
	return success;
};

export async function fetchRelight(
	params: {
		inputs: {
			$img: string;
			$option: string;
		};
		params_index: number;
		tool_document_id: string;
		jwt: string;
	},
	executionContext: any,
	messageId: string,
): Promise<string | false> {
	return fetchGatewayInferenceJob(params, executionContext, messageId);
}

export function useListenRelightMessage() {
	useListenFromRenderer([
		{
			key: "relight",
			onMessage: async (message) => {
				const success = await callRelight(
					message.id,
					message.values.jwt,
					message.values.option,
					message.values.tool_document_id,
				);
				postToRenderer([
					{
						key: "finish",
						id: uuidv4(),
						values: {
							id: message.id,
							status: success ? "success" : "error",
						},
					},
				]);
			},
		},
		{
			key: "relightAuto",
			onMessage: async (message) => {
				const success = await callRelightAuto(
					message.id,
					message.values.jwt,
					message.values.option_index,
					message.values.tool_document_id,
				);
				postToRenderer([
					{
						key: "finish",
						id: uuidv4(),
						values: {
							id: message.id,
							status: success ? "success" : "error",
						},
					},
				]);
			},
		},
	]);
}
